/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Compliance_SaleAndTrading_CoveredAttestationQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
  cmgEntityKey: Types.Scalars['String']['input'];
  certificateType: Types.CertificateType;
}>;

export type Compliance_SaleAndTrading_CoveredAttestationQuery = {
  readonly __typename?: 'Query';
  readonly basicPublishedOffering: {
    readonly __typename?: 'BasicPublishedOfferingProfile';
    readonly id: string;
    readonly type: Types.OfferingType;
  };
  readonly indicationAttestation: {
    readonly __typename?: 'IndicationAttestation';
    readonly certificateType: Types.CertificateType;
    readonly cmgEntityKey: string;
    readonly status: Types.AttestationFormStatus;
  };
  readonly coveredAttestation: {
    readonly __typename?: 'Attestation';
    readonly attestationForm?: {
      readonly __typename?: 'AttestationForm';
      readonly firmName: string;
      readonly expirationDate?: string | null;
      readonly certificateType: Types.CertificateType;
      readonly signatoryDate: string;
      readonly effectiveDate: string;
      readonly cityStateZip?: string | null;
      readonly addressLine1: string;
      readonly isBlanketForm: boolean;
      readonly firmIdentifier?: string | null;
      readonly bankRequesterCmgEntityKey?: string | null;
      readonly envelopeId?: string | null;
      readonly primaryFirmCmgEntityKey?: string | null;
      readonly id: string;
      readonly signers: ReadonlyArray<{
        readonly __typename?: 'Signer';
        readonly title: string;
        readonly name: string;
        readonly email: string;
        readonly telephone: string;
      }>;
    } | null;
  };
};

export const Compliance_SaleAndTrading_CoveredAttestationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Compliance_SaleAndTrading_CoveredAttestation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cmgEntityKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'certificateType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CertificateType' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'basicPublishedOffering' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'indicationAttestation' },
            name: { kind: 'Name', value: 'indicationAttestation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'certificateType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'certificateType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cmgEntityKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cmgEntityKey' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offeringId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'coveredAttestation' },
            name: { kind: 'Name', value: 'coveredAttestation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'certificateType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'certificateType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cmgEntityKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cmgEntityKey' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attestationForm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signatoryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cityStateZip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBlanketForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firmIdentifier' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bankRequesterCmgEntityKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'envelopeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryFirmCmgEntityKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCompliance_SaleAndTrading_CoveredAttestationQuery__
 *
 * To run a query within a React component, call `useCompliance_SaleAndTrading_CoveredAttestationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompliance_SaleAndTrading_CoveredAttestationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompliance_SaleAndTrading_CoveredAttestationQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      cmgEntityKey: // value for 'cmgEntityKey'
 *      certificateType: // value for 'certificateType'
 *   },
 * });
 */
export function useCompliance_SaleAndTrading_CoveredAttestationQuery(
  baseOptions: Apollo.QueryHookOptions<
    Compliance_SaleAndTrading_CoveredAttestationQuery,
    Compliance_SaleAndTrading_CoveredAttestationQueryVariables
  > &
    (
      | { variables: Compliance_SaleAndTrading_CoveredAttestationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Compliance_SaleAndTrading_CoveredAttestationQuery,
    Compliance_SaleAndTrading_CoveredAttestationQueryVariables
  >(Compliance_SaleAndTrading_CoveredAttestationDocument, options);
}
export function useCompliance_SaleAndTrading_CoveredAttestationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Compliance_SaleAndTrading_CoveredAttestationQuery,
    Compliance_SaleAndTrading_CoveredAttestationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Compliance_SaleAndTrading_CoveredAttestationQuery,
    Compliance_SaleAndTrading_CoveredAttestationQueryVariables
  >(Compliance_SaleAndTrading_CoveredAttestationDocument, options);
}
// @ts-ignore
export function useCompliance_SaleAndTrading_CoveredAttestationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Compliance_SaleAndTrading_CoveredAttestationQuery,
    Compliance_SaleAndTrading_CoveredAttestationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  Compliance_SaleAndTrading_CoveredAttestationQuery,
  Compliance_SaleAndTrading_CoveredAttestationQueryVariables
>;
export function useCompliance_SaleAndTrading_CoveredAttestationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Compliance_SaleAndTrading_CoveredAttestationQuery,
        Compliance_SaleAndTrading_CoveredAttestationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  Compliance_SaleAndTrading_CoveredAttestationQuery | undefined,
  Compliance_SaleAndTrading_CoveredAttestationQueryVariables
>;
export function useCompliance_SaleAndTrading_CoveredAttestationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Compliance_SaleAndTrading_CoveredAttestationQuery,
        Compliance_SaleAndTrading_CoveredAttestationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Compliance_SaleAndTrading_CoveredAttestationQuery,
    Compliance_SaleAndTrading_CoveredAttestationQueryVariables
  >(Compliance_SaleAndTrading_CoveredAttestationDocument, options);
}
export type Compliance_SaleAndTrading_CoveredAttestationQueryHookResult = ReturnType<
  typeof useCompliance_SaleAndTrading_CoveredAttestationQuery
>;
export type Compliance_SaleAndTrading_CoveredAttestationLazyQueryHookResult = ReturnType<
  typeof useCompliance_SaleAndTrading_CoveredAttestationLazyQuery
>;
export type Compliance_SaleAndTrading_CoveredAttestationSuspenseQueryHookResult = ReturnType<
  typeof useCompliance_SaleAndTrading_CoveredAttestationSuspenseQuery
>;
export type Compliance_SaleAndTrading_CoveredAttestationQueryResult = Apollo.QueryResult<
  Compliance_SaleAndTrading_CoveredAttestationQuery,
  Compliance_SaleAndTrading_CoveredAttestationQueryVariables
>;

import { makeMockResponse } from '../../../../../../../../graphql/mock-response';

export const makeCompliance_SaleAndTrading_CoveredAttestationMockResponse = makeMockResponse<
  Compliance_SaleAndTrading_CoveredAttestationQueryVariables,
  Compliance_SaleAndTrading_CoveredAttestationQuery
>(Compliance_SaleAndTrading_CoveredAttestationDocument);
